/* eslint-disable */

window.hj = window.hj || [];

function loadHotjar(id) {

    const url = 'https://static.hotjar.com/c/hotjar-';

    window.hj=window.hj||function(){(window.hj.q=window.hj.q||[]).push(arguments)};
    window._hjSettings={hjid:id,hjsv:6};
    const a=document.getElementsByTagName('head')[0];
    const r=document.createElement('script');r.async=1;
    r.src=url+window._hjSettings.hjid+'.js?sv='+window._hjSettings.hjsv;
    a.appendChild(r);

}

export default loadHotjar;
